/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetAllIoes200ResponseIoeInnerSetting } from './GetAllIoes200ResponseIoeInnerSetting';
import {
    GetAllIoes200ResponseIoeInnerSettingFromJSON,
    GetAllIoes200ResponseIoeInnerSettingFromJSONTyped,
    GetAllIoes200ResponseIoeInnerSettingToJSON,
    GetAllIoes200ResponseIoeInnerSettingToJSONTyped,
} from './GetAllIoes200ResponseIoeInnerSetting';
import type { GetAllIoes200ResponseIoeInnerException } from './GetAllIoes200ResponseIoeInnerException';
import {
    GetAllIoes200ResponseIoeInnerExceptionFromJSON,
    GetAllIoes200ResponseIoeInnerExceptionFromJSONTyped,
    GetAllIoes200ResponseIoeInnerExceptionToJSON,
    GetAllIoes200ResponseIoeInnerExceptionToJSONTyped,
} from './GetAllIoes200ResponseIoeInnerException';

/**
 * 
 * @export
 * @interface GetAllIoes200ResponseIoeInner
 */
export interface GetAllIoes200ResponseIoeInner {
    /**
     * Unique identifier of the IoE check type (e.g. `user-password-never-expires`).
     */
    ioeIdPk?: string;
    /**
     * `ad` — on-premises AD only; `entra` — Entra ID only; `hybrid` — both environments.
     */
    ioeType?: GetAllIoes200ResponseIoeInnerIoeTypeEnum;
    /**
     * Human-readable name of the IoE check.
     */
    title?: string;
    /**
     * Brief description of what the IoE check evaluates.
     */
    description?: string;
    /**
     * Effective criticality for this client: `critical`, `high`, `medium`, `low`, or `info`.
     */
    criticality?: string;
    /**
     * How much this IoE reduces the security score when findings are active.
     */
    scoreImpact?: number;
    /**
     * Total number of active findings for this IoE check.
     */
    totalFindingsCount?: number;
    /**
     * Number of findings that have been marked as exceptions (suppressed).
     */
    totalExceptionsCount?: number;
    /**
     * True if every active finding has been excepted or the IoE itself has an exception, effectively silencing this IoE.
     */
    allFindingsHaveException?: boolean;
    /**
     * True if the IoE has no object findings, so an exception can only be set on the IoE itself (see `updateIoeException`).
     */
    canExceptIoe?: boolean;
    /**
     * 
     */
    exception?: GetAllIoes200ResponseIoeInnerException | null;
    /**
     * 
     */
    setting?: GetAllIoes200ResponseIoeInnerSetting;
    /**
     * If the check was skipped, the reason (e.g. missing data source). Null when the check ran normally.
     */
    skippedReason?: string | null;
    /**
     * Whether this IoE check is enabled and producing findings.
     */
    isActive?: boolean;
}


/**
 * @export
 */
export const GetAllIoes200ResponseIoeInnerIoeTypeEnum = {
    Ad: 'ad',
    Entra: 'entra',
    Hybrid: 'hybrid',
} as const;
export type GetAllIoes200ResponseIoeInnerIoeTypeEnum = typeof GetAllIoes200ResponseIoeInnerIoeTypeEnum[keyof typeof GetAllIoes200ResponseIoeInnerIoeTypeEnum];


/**
 * Check if a given object implements the GetAllIoes200ResponseIoeInner interface.
 */
export function instanceOfGetAllIoes200ResponseIoeInner(value: object): value is GetAllIoes200ResponseIoeInner {
    return true;
}

export function GetAllIoes200ResponseIoeInnerFromJSON(json: any): GetAllIoes200ResponseIoeInner {
    return GetAllIoes200ResponseIoeInnerFromJSONTyped(json, false);
}

export function GetAllIoes200ResponseIoeInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAllIoes200ResponseIoeInner {
    if (json == null) {
        return json;
    }
    return {
        
        'ioeIdPk': json['ioeIdPk'] == null ? undefined : json['ioeIdPk'],
        'ioeType': json['ioeType'] == null ? undefined : json['ioeType'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'criticality': json['criticality'] == null ? undefined : json['criticality'],
        'scoreImpact': json['scoreImpact'] == null ? undefined : json['scoreImpact'],
        'totalFindingsCount': json['totalFindingsCount'] == null ? undefined : json['totalFindingsCount'],
        'totalExceptionsCount': json['totalExceptionsCount'] == null ? undefined : json['totalExceptionsCount'],
        'allFindingsHaveException': json['allFindingsHaveException'] == null ? undefined : json['allFindingsHaveException'],
        'canExceptIoe': json['canExceptIoe'] == null ? undefined : json['canExceptIoe'],
        'exception': json['exception'] === undefined ? undefined : json['exception'] === null ? null : GetAllIoes200ResponseIoeInnerExceptionFromJSON(json['exception']),
        'setting': json['setting'] == null ? undefined : GetAllIoes200ResponseIoeInnerSettingFromJSON(json['setting']),
        'skippedReason': json['skippedReason'] === undefined ? undefined : json['skippedReason'] === null ? null : json['skippedReason'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
    };
}

export function GetAllIoes200ResponseIoeInnerToJSON(json: any): GetAllIoes200ResponseIoeInner {
    return GetAllIoes200ResponseIoeInnerToJSONTyped(json, false);
}

export function GetAllIoes200ResponseIoeInnerToJSONTyped(value?: GetAllIoes200ResponseIoeInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ioeIdPk': value['ioeIdPk'],
        'ioeType': value['ioeType'],
        'title': value['title'],
        'description': value['description'],
        'criticality': value['criticality'],
        'scoreImpact': value['scoreImpact'],
        'totalFindingsCount': value['totalFindingsCount'],
        'totalExceptionsCount': value['totalExceptionsCount'],
        'allFindingsHaveException': value['allFindingsHaveException'],
        'canExceptIoe': value['canExceptIoe'],
        'exception': GetAllIoes200ResponseIoeInnerExceptionToJSON(value['exception']),
        'setting': GetAllIoes200ResponseIoeInnerSettingToJSON(value['setting']),
        'skippedReason': value['skippedReason'],
        'isActive': value['isActive'],
    };
}

